import {ReactComponent as IconSearch} from '#/components/icons/ico-search-white.svg';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const HeaderSearchButton: FunctionComponent<{className?: string; onClick: () => void}> = ({
  onClick,
  className = '',
}) => (
  <button
    className={`aspect-square flex gap-2 p-2 bg-gray-700 justify-center items-center h-full rounded-lg hover:opacity-70 group relative ${className}`}
    onClick={onClick}
  >
    <IconSearch className='w-3.5 h-3.5' />
  </button>
);

export const HeaderSearchCloseButton: FunctionComponent<{className?: string; onClick: () => void}> = ({
  onClick,
  className = '',
}) => {
  const {t} = useTranslation('translation');

  return (
    <button
      className={`flex gap-2 p-2 justify-between items-center h-full rounded text-sm text-gray-500 border border-gray-500 group relative uppercase ${className}`}
      onClick={onClick}
    >
      {t('actions.close')}
    </button>
  );
};
